import { Box, TableCell, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import dayjs from 'dayjs';

export function TableCellComponent({ tableId, cellData, sx, rowData }) {
  const navigate = useNavigate();

  const handleBookClick = (rowData) => {
    navigate(`/chapters?bookId=${rowData?.id}`);
  };

  const handleChapterClick = (rowData) => {
    navigate(`/contents?chapterId=${rowData?.id}`);
  };

  const getDirection = (text) => {
    const firstChar = text ? text?.trim().charAt(0) : "";
    return /[\u0600-\u06FF]/.test(firstChar) ? 'rtl' : 'ltr'; // Urdu/Arabic Unicode range
  };


  const renderCellContent = () => {
    switch (tableId) {
      case 'url':
        return (
          <Typography
            component="a"
            href={cellData}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-block',
              maxWidth: '300px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: 'primary.main',
              // textDecoration: 'underline',
              fontFamily: "'Jameel Noori Nastaleeq', serif",
              maxWidth: 200,

            }}
            title={cellData}
          >
            {cellData}
          </Typography>
        );

      case 'bookName':
        return (
          <Typography
            sx={{
              direction: getDirection(cellData),
              // textAlign: getDirection(cellData) === 'rtl' ? 'right' : 'left',
              color: 'primary.main',
              textDecoration: 'underline',
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' },
              fontFamily: "'Jameel Noori Nastaleeq', serif",
            }}
            onClick={() => handleBookClick(rowData)}
          >
            {cellData}
          </Typography>
        )
      case 'chapterName':
        return (
          <Typography
            sx={{
              direction: getDirection(rowData?.Chapter?.Book?.bookName),
              // textAlign: getDirection(rowData?.Chapter?.Book?.bookName) === 'rtl' ? 'right' : 'left',
              color: 'primary.main',
              textDecoration: 'underline',
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' },
              fontFamily: "'Jameel Noori Nastaleeq', serif",
            }}
            onClick={() => handleChapterClick(rowData)}
          >
            {cellData}
          </Typography>
        )

      case 'coverImage':
        return (
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              overflow: 'hidden',
              border: '2px dashed #ccc',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              cursor: 'pointer',
              backgroundColor: '#f5f5f5',
            }}
          >
            {cellData ? (
              <img
                src={cellData}
                alt="Cover"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <PhotoCameraIcon sx={{ fontSize: 32, color: '#888' }} />
            )}
          </Box>
        )
        case 'contentBookId':
        return (
          <Typography
           sx={{
            direction: getDirection(rowData?.Chapter?.Book?.bookName),
            fontFamily: "'Jameel Noori Nastaleeq', serif",
            // textAlign: getDirection(rowData?.Chapter?.Book?.bookName) === 'rtl' ? 'right' : 'left',
           }}
          >
            {rowData?.Chapter?.Book?.bookName}
          </Typography>
        )
        case 'bookNoContent':
        return (
          <Typography
          sx={{
            fontFamily: "'Jameel Noori Nastaleeq', serif",
          }}
          >
            {rowData?.Chapter?.Book?.bookNo}
          </Typography>
        )
        case 'chapterNoContent':
        return (
          <Typography
          sx={{
            fontFamily: "'Jameel Noori Nastaleeq', serif",
          }}
          >
            {rowData?.Chapter?.chapterNo}
          </Typography>
        )
      case 'scheduledAt':
        return (
          <Typography
            sx={{
              fontFamily: "'Jameel Noori Nastaleeq', serif",
            }}
          >
            {cellData ? dayjs(cellData).format('DD/MM/YYYY HH:mm') : 'N/A'}
          </Typography>
        )
      // You can add more cases here in the future like:
      // case 'chapterId':
      //   return ...

      default:
        return cellData;
    }
  };

  return (
    <TableCell align="left" sx={{ fontFamily: "'Jameel Noori Nastaleeq', serif", fontSize: '16px', ...sx }}>
      {renderCellContent()}
    </TableCell>
  );
}

export default TableCellComponent;
